import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core'
import { NgForm } from '@angular/forms'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs'
import { UserAdmin } from '../../../models/UserAdmin'
import { ViewValidation } from '../../../_helpers/ViewValidation'
import { NotificationService } from '../../../services/notification.service'
import { UserService } from '../../../services/user.service'
import { CompanyService } from '../../../services/company.service'
import { Company, ICompanyRole } from '../../../models/Company'
import { getLengthTable, getLoggedUser, setLengthTable } from 'src/app/_helpers/LocalStorage'
import { IRoles, UserCreate } from 'src/app/models/User'
import { insertOrRemoveClassInScrollButton, removeToolTip, rolesCompany, scrollToConteiner } from 'src/app/_helpers/Utils'
import { CompanyServiceProvider } from 'src/app/models/CompanyServiceProvider'
import { CompanyServiceProviderService } from 'src/app/services/company-service-provider'
import { SearchTruncated, searchTruncatedUsers } from 'src/app/_helpers/SearchTruncated'

@Component({
	selector: 'app-company-admin',
	templateUrl: './company-admin.component.html'
})
export class CompanyAdminComponent implements OnInit, AfterViewInit {

	@ViewChild('form') public form: NgForm
	@ViewChild(DataTableDirective) public dtElement: DataTableDirective
	@ViewChild('tableConteiner')
	public tableConteiner: ElementRef<HTMLDivElement>

	public refreshTable: Subject<any> = new Subject()
	public datatableOptions: DataTables.Settings = {}
	public ViewValidation: ViewValidation = new ViewValidation()

	public sessionUser: UserAdmin = getLoggedUser()
	public companyId: string = localStorage.getItem('companyId')
	public companiesServiceProvider: Array<CompanyServiceProvider> = []
	public roles: Array<IRoles> = rolesCompany
	public company: Company = new Company()
	public licences: number = 0
	public licensesCount = {
		CUSTOMER: 0,
		USER: 0,
		INVENTOR: 0,
		EVALUATOR: 0,
		OPERATOR: 0
	}
	public seeActions: boolean = true
	public createOrUpdatePermition: boolean = false

	public users: Array<UserCreate> = []
	public newUser: UserCreate = new UserCreate()

	public telephoneMask: string = '(00) 0000-00009'

	public open: boolean = false
	public companyIsActive: boolean = false
	private isAdmin: boolean = false
	public disableSaveButton: boolean = false
	public openBlockUsers: boolean = false
	public openUnblockUsers: boolean = false
	public enableEditForm: boolean = false
	public enableCrea: boolean = false
	public enableCompanyServiceProvider: boolean = false

	private checkedBlockedUsers: Array<string> = []
	private checkedUnblockedUsers: Array<string> = []
	private usersSelected: Array<string> = []


	private assignmentsModules: Array<{
		moduleName: string;
		subModules: Array<{
			name: string;
			assignments: Array<{
				name: string;
				readableName: string;
				description: string;
			}>;
		}>;

		view: boolean;
		isSelected: boolean;
	}>

	public usersSearchTruncated: Array<SearchTruncated> = searchTruncatedUsers
	public searchTruncatedStringFormated: string = ''

	public showScrollUpButton: boolean = false
	public lengthTable: string = getLengthTable()

	constructor(
		public notificationService: NotificationService,
		private companyService: CompanyService,
		private userService: UserService,
		private companyServiceProviderService: CompanyServiceProviderService
	) { }

	public ngAfterViewInit(): void {
		this.refreshTable.next()
	}

	public ngOnInit(): void {
		this.isAdmin = this.sessionUser.roles.includes('GENERAL_ADMIN')

		this.seeActions = Boolean(
			this.isAdmin || (
			this.sessionUser.assignments &&
			(
				this.sessionUser.assignments.includes('USER_UPDATE') ||
				this.sessionUser.assignments.includes('USER_CHANGE_STATUS') ||
				this.sessionUser.assignments.includes('USER_RESEND_MAIL') ||
				this.sessionUser.assignments.includes('USER_BLOCK')
			))
		)

		this.createOrUpdatePermition = Boolean(
			this.isAdmin || (
				this.sessionUser.assignments &&
				(
					this.sessionUser.assignments.includes('USER_CREATE') ||
					this.sessionUser.assignments.includes('USER_UPDATE')
				)
			)
		)

		this.checkCompanyStatus()
		this.fetchCompany()
		this.fetchUsers()

		if (this.createOrUpdatePermition) {
			this.getCompanyModuleAssignments()
			this.getCompaniesServiceProvider()
		}

		document.querySelector('main').className = ''

		const observer =
			new IntersectionObserver( ([entry]) => {
				this.showScrollUpButton = entry.isIntersecting

				if (entry.isIntersecting) {
					insertOrRemoveClassInScrollButton()
				}
			})

		observer.observe(this.tableConteiner.nativeElement)
	}

	public async getCompanyModuleAssignments(): Promise<void> {
		try {
			this.assignmentsModules =
				await this.companyService.getCompanyModuleAssignments(this.companyId).toPromise()

			this.assignmentsModules.map(assignmentModule => Object.assign(assignmentModule, { isSelected: false, view: false }))
		} catch (err) {
			console.log(err)
		}
	}


	public async checkCompanyStatus(): Promise<void> {
		try {
			const companyStatus: string =
				await this.companyService.checkStatus(this.companyId).toPromise()
			this.companyIsActive = Boolean(companyStatus === 'ACTIVE')
		} catch (err) { }
	}

	public async fetchUsers(): Promise<void> {
		this.userService.getUsers({
			companyId: this.companyId,
			searchTruncated: this.searchTruncatedStringFormated
		}).subscribe(data => {
			this.users = data
			this.setupDatatables()
			this.rerender()
		})
	}

	public async getCompaniesServiceProvider(): Promise<void> {
		try {
			this.companiesServiceProvider =
				await this.companyServiceProviderService.getCompaniesServiceProvider({
					companyId: this.companyId,
					skip: 0,
					limit: 100,
					order: 'CNPJ',
					typeOrder: 'desc'
				}).toPromise()
		} catch (err) {
			this.notificationService.notify(err.error.message, err.error.statusCode || 400)
		}
	}

	public async fetchCompany(): Promise<void> {
		try {
			this.company =
				await this.companyService.detailCompany(this.companyId).toPromise()
			this.setLicences()
		} catch (err) { }
	}

	public setLicences() {
		const licencesAdmin: number = this.company.qtd_admins - this.company.qtd_adminsUsed
		const licencesInventor: number = this.company.qtd_inventors - this.company.qtd_inventorsUsed
		const licencesEvaluator: number = this.company.qtd_evaluators - this.company.qtd_evaluatorsUsed
		const licencesOperator: number = this.company.qtd_operators - this.company.qtd_operatorsUsed

		this.licensesCount.CUSTOMER = licencesAdmin
		this.licensesCount.USER = licencesAdmin
		this.licensesCount.INVENTOR = licencesInventor
		this.licensesCount.EVALUATOR = licencesEvaluator
		this.licensesCount.OPERATOR = licencesOperator

		this.disableRoleByLicenses()

		this.licences = licencesAdmin + licencesInventor + licencesEvaluator + licencesOperator
	}

	private disableRoleByLicenses() {
		this.roles = rolesCompany.map(role => ({
			...role,
			selectable: this.licensesCount[role.value] > 0
		}))
	}

	public isSelected(item: ICompanyRole): boolean {
		return this.newUser.roles && this.newUser.roles.includes(item.value)
	}

	public onOptionClick(event: Event, item: ICompanyRole): void {
		if (!item.selectable && !this.isSelected(item)) {
			item.disabled = true
			event.stopPropagation()
		}
	}

	private setupDatatables(): void {
		this.datatableOptions = {
			language: {
				processing: 'Processando...',
				lengthMenu: '_MENU_ resultados por página',
				info: 'Mostrando de _START_ até _END_ de _TOTAL_ registros',
				infoEmpty: 'Mostrando 0 até 0 de 0 registros',
				infoFiltered: '',
				infoPostFix: '',
				zeroRecords: '...',
				loadingRecords: 'Cargando...',
				emptyTable: 'Nenhum registro encontrado',
				paginate: {
					first: 'Primero',
					previous: 'Anterior',
					next: 'Próximo',
					last: 'Último'
				},
				aria: {
					sortAscending: ': Ordenar colunas de forma ascendente',
					sortDescending: ': Ordenar colunas de forma ascendente'
				}
			},
			pagingType: 'full_numbers',
			paging: true,
			searching: true,
			ordering: true,
			info: true,
			autoWidth: false,
			pageLength: Number(this.lengthTable),
			lengthChange: false,
			columnDefs: [
				{
					targets: 'no-sort',
					orderable: false,
					width: '.1%'
				}
			]
		}
	}

	public openModal(userSelect?: UserCreate) {
		if (userSelect) {
			const enableUpdate = Boolean(
				this.sessionUser.assignments &&
				this.sessionUser.assignments.includes('USER_UPDATE') &&
				userSelect._id !== this.sessionUser._id
			)

			if (!(enableUpdate || this.isAdmin)) {
				this.notificationService.notify('Você não tem permissão para editar este usuário', 400)
				return
			}

			this.newUser = JSON.parse(JSON.stringify(userSelect))
			setTimeout(() => {
				this.telMask(this.newUser.telephone)
			}, 250)

			this.disableRoleByLicenses()

			this.roles = Array.from(
				new Set([
					...this.roles,
					...this.roles.filter(role =>
						this.newUser.roles.includes(role.value)
					)
				])
			)

		} else {
			this.roles = rolesCompany
			this.disableRoleByLicenses()

			const enableCreate = Boolean(
				this.sessionUser.assignments &&
				this.sessionUser.assignments.includes('USER_CREATE')
			)
			if (!(enableCreate || this.isAdmin)) return

			this.newUser = new UserCreate()
		}

		this.setEnableCrea()
		this.setCompanyserviceProvider()
		this.closeAssignmentsView()

		this.open = true
	}

	public closeAssignmentsView() {
		this.assignmentsModules.map(assignmentModule => Object.assign(assignmentModule, { view: false }))
	}

	public closeModal() {
		this.open = false
		this.disableSaveButton = true
	}

	public setDisableSaveButton() {
		this.disableSaveButton = false
	}

	public async createOrEditUser(isEditing?: boolean): Promise<void> {
		try {
			this.newUser.companyId = this.company._id
			let response: any

			if (isEditing) {
				const response =
					await this.userService.patchUser(this.newUser).toPromise()
				this.refreshNewUser()
				this.notificationService.notify(response.message, 200)

				return
			}

			response =
				await this.userService.addUser(this.newUser).toPromise()
			this.refreshNewUser()
			this.notificationService.notify(response.message, 200)
		} catch (err) {
			this.notificationService.notify(err.error.message, err.error.statusCode || 400)
		}
	}

	public async removeUser(): Promise<void> {
		try {
			const response: any =
				await this.userService.changeUserStatus(this.newUser._id).toPromise()

			this.refreshNewUser()
			this.notificationService.notify(response.message, 200)
		} catch (err) { }
	}

	public async resendEmail(user: UserCreate): Promise<void> {
		const hasPermitionUpdate = Boolean(
			this.sessionUser.assignments &&
			this.sessionUser.assignments.includes('USER_RESEND_MAIL')
		)
		if (!(this.isAdmin || hasPermitionUpdate)) return

		try {
			const response: any =
				await this.userService.sendEmail(user._id).toPromise()
			this.notificationService.notify(response.message, 200)
		} catch (err) { }
	}

	public async blockManyUsers() {
		try {
			const response =
				await this.userService.blockUsers(this.checkedUnblockedUsers).toPromise()
			this.notificationService.notify(response.message, 200)

			this.usersSelected = this.usersSelected.filter(id => !this.checkedUnblockedUsers.includes(id))
			this.checkedUnblockedUsers = []
			await this.fetchUsers()
			this.closeModalBlockUsers()
		} catch (err) {
			console.log(err)
		}
	}

	public async unblockManyUsers() {
		try {
			const response =
				await this.userService.unblockUsers(this.checkedBlockedUsers).toPromise()
			this.notificationService.notify(response.message, 200)

			this.usersSelected = this.usersSelected.filter(id => !this.checkedBlockedUsers.includes(id))
			this.checkedBlockedUsers = []
			await this.fetchUsers()
			this.closeModalUnblockUsers()
		} catch (err) {
			console.log(err)
		}
	}

	public async unblockUser(user: UserCreate, index: number): Promise<void> {
		try {
			removeToolTip()
			const response =
				await this.userService.unblockUsers([user._id]).toPromise()

			this.notificationService.notify(response.message, 200)
			this.users[index].blocked = false
			this.checkedBlockedUsers = this.checkedBlockedUsers.filter(id => id !== user._id)
			this.usersSelected = this.usersSelected.filter(id => id !== user._id)
		} catch (err) {
			console.log(err)
		} finally {
			setTimeout(() => {
				removeToolTip()
			}, 1000)
		}
	}

	public async blockUser(user: UserAdmin, index: number): Promise<void> {
		try {
			removeToolTip()
			const response =
				await this.userService.blockUsers([user._id]).toPromise()

			this.notificationService.notify(response.message, 200)
			this.users[index].blocked = true
			this.checkedUnblockedUsers = this.checkedUnblockedUsers.filter(id => id !== user._id)
			this.usersSelected = this.usersSelected.filter(id => id !== user._id)
		} catch (err) {
			console.log(err)
		} finally {
			setTimeout(() => {
				removeToolTip()
			}, 1000)
		}
	}

	public uncheckUser(user: UserCreate, index: number) {
		if (user.blocked) {
			this.checkedBlockedUsers.splice(this.checkedBlockedUsers.indexOf(user._id), 1)
		} else {
			this.checkedUnblockedUsers.splice(this.checkedUnblockedUsers.indexOf(user._id), 1)
		}
		this.usersSelected.splice(this.usersSelected.indexOf(user._id), 1)
	}

	public checkUser(user: UserAdmin, index: number) {
		if (user.blocked) {
			this.checkedBlockedUsers.push(user._id)
		} else {
			this.checkedUnblockedUsers.push(user._id)
		}
		this.usersSelected.push(user._id)
	}

	public closeModalBlockUsers(): void {
		this.openBlockUsers = false
		document.querySelector('main').className = ''
	}

	public openModalBlockUsers(): void {
		if (this.checkedUnblockedUsers.length == 0) {
			return
		}
		this.openBlockUsers = true
		document.querySelector('main').className = 'modal-active'
	}

	public closeModalUnblockUsers(): void {
		this.openUnblockUsers = false
		document.querySelector('main').className = ''
	}

	public openModalUnblockUsers(): void {
		if (this.checkedBlockedUsers.length == 0) {
			return
		}
		this.openUnblockUsers = true
		document.querySelector('main').className = 'modal-active'
	}

	public handleSync(event: any): void {
		event.target.className = 'sync'
		setTimeout(() => {
			event.target.className = ''
		}, 2000)
	}

	private changeUserStatus(user: UserAdmin): void {
		this.userService.changeUserStatus(user._id).subscribe(() => console.log('Status changed'))
		user.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
	}

	public refreshNewUser(): void {
		this.form.reset()
		this.closeModal()
		this.fetchUsers()
		this.fetchCompany()
		this.newUser = new UserCreate()
	}

	public telMask(value: any): void {
		if (value.length === 15) {
			this.telephoneMask = '(00) 00000-0000'

			return
		}
		if (value.length < 15) {
			this.telephoneMask = '(00) 0000-00009'

			return
		}
	}

	public rerender(): void {
		if (this.dtElement.dtInstance) {
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				document.querySelector('table').classList.add('hide')
				dtInstance.destroy()
				this.refreshTable.next()
				setTimeout(() => {
					document.querySelector('table').classList.remove('hide')
				}, 500)
			})
		} else {
			this.refreshTable.next()
		}
	}

	public setEnableCrea() {
		const isInventory = Boolean(this.newUser.roles.includes('INVENTOR'))
		const isEvaluator = Boolean(this.newUser.roles.includes('EVALUATOR'))

		this.enableCrea = Boolean(isInventory || isEvaluator)

		if (!this.enableCrea) {
			this.newUser.crea = ''
		}
	}

	public setCompanyserviceProvider() {
		this.enableCompanyServiceProvider = Boolean(this.newUser.roles.includes('OPERATOR'))

		if (!this.enableCompanyServiceProvider) {
			this.newUser.companyServiceProvider = ''
		}
	}

	public validateCrea() {
		const isEvaluator = Boolean(this.newUser.roles.includes('EVALUATOR'))

		if (isEvaluator && !this.newUser.crea) {
			return false
		}

		return true
	}

	public toggleSubmodules(index: number) {
		this.assignmentsModules[index].isSelected = !this.assignmentsModules[index].isSelected
		this.assignmentsModules[index].view = !this.assignmentsModules[index].view

		this.setDisableSaveButton()
	}

	public setAllModule(moduleIndex: number) {
		const module = this.assignmentsModules[moduleIndex]
		const allAssignmentsSelected = this.isModuleSelected(moduleIndex)

		module.subModules.forEach(subModule => {
			subModule.assignments.forEach(assignment => {
				const assignmentIndex = this.newUser.assignments.indexOf(assignment.name)
				if (allAssignmentsSelected) {
					if (assignmentIndex > -1) {
						this.newUser.assignments.splice(assignmentIndex, 1)
					}
				} else {
					if (assignmentIndex === -1) {
						this.newUser.assignments.push(assignment.name)
					}
				}
			})
		})

		this.setDisableSaveButton()
	}

	/**
	 * Define ou remove uma atribuição para um usuário com base nos índices do módulo, submódulo e nome da atribuição.
	 *
	 * @param {number} moduleIndex - Índice do módulo no array assignmentsModules.
	 * @param {number} subModuleIndex - Índice do submódulo no array subModules do módulo.
	 * @param {string} assignmentName - Nome da atribuição a ser adicionada ou removida.
	 */
	public setAssignment(moduleIndex: number, subModuleIndex: number, assignmentName: string) {
		// Encontra o índice da atribuição no array de atribuições do usuário
		const assignmentIndex = this.newUser.assignments.indexOf(assignmentName)

		// Obtém o submódulo com base nos índices fornecidos
		const subModule = this.assignmentsModules[moduleIndex].subModules[subModuleIndex]

		// Regex para validar se o assignment é de leitura
		const termRegexRead = new RegExp('READ$', 'i')

		// Verifica se o assignment é de leitura
		const read = termRegexRead.test(assignmentName)

		// Verifica se a atribuição já existe no usuário
		if (assignmentIndex > -1) {
			// Regras específicas para desmarcar a atribuição 'Leitura'
			if (read) {
				// Verifica se outras atribuições estão marcadas exceto 'Leitura'
				const otherAssignmentsMarked = subModule.assignments.some(assignment =>
					this.newUser.assignments.includes(assignment.name) && assignment.readableName !== 'Leitura')

				// Se outras atribuições estiverem marcadas, não permite desmarcar 'Leitura'
				if (otherAssignmentsMarked) {
					return
				}
			}

			// Regras específicas para o submódulo 'Relatório'
			if (subModule.name === 'Relatório') {

				// Verifica se há atribuições marcadas em 'Relatório' excluindo 'Leitura'
				const assignmentsReport = subModule.assignments.filter(assignment =>
					this.newUser.assignments.includes(assignment.name) && assignment.readableName !== 'Leitura')

				// Se houver atribuições marcadas em 'Relatório', impede a desmarcação
				if (read && assignmentsReport.length > 0) {
					return
				}
			}

			// Remove a atribuição do usuário
			this.newUser.assignments.splice(assignmentIndex, 1)
		} else {
			// Adiciona a atribuição ao usuário
			this.newUser.assignments.push(assignmentName)

			// Regras específicas para o submódulo 'Relatório'
			if (subModule.name === 'Relatório') {
				// Verifica se alguma atribuição está marcada em 'Relatório'
				const isAnyAssignmentChecked = subModule.assignments.some(assignment =>
					this.newUser.assignments.includes(assignment.name))

				// Se alguma atribuição estiver marcada, adiciona 'Leitura' de 'Histórico' ao usuário
				if (isAnyAssignmentChecked) {
					// Encontra o submódulo 'Histórico' e a atribuição 'Leitura'
					const subModuleHistoric =
						this.assignmentsModules[moduleIndex].subModules.find(subModule => subModule.name === 'Histórico')

					if (subModuleHistoric) {
						const leituraAssignment = subModuleHistoric.assignments.find(assignment => assignment.readableName === 'Leitura')
						if (leituraAssignment && !this.newUser.assignments.includes(leituraAssignment.name)) {
							this.newUser.assignments.push(leituraAssignment.name)
						}
					}

					// Regex para validar se o assignment é de atualização de todos os relatórios
					const termRegexUpdate = new RegExp('UPDATE_ALL$', 'i')

					// Verifica se a atribuição é do tipo Atualizar todos
					const updateAll: boolean = Boolean(
						termRegexUpdate.test(assignmentName)
					)

					// Se o usuário selecionou atualização de todos relatórios
					if (updateAll) {
						const hasFoundReadAllAssignment =
							subModule.assignments.find(assignment => assignment.readableName === 'Leitura de todos')

						if (hasFoundReadAllAssignment && !this.newUser.assignments.includes(hasFoundReadAllAssignment.name)) {
							this.newUser.assignments.push(hasFoundReadAllAssignment.name)
						}
					}
				}
			}

			// Regras para adicionar 'Leitura' se a atribuição não for 'Leitura'
			if (!read) {
				// Adiciona 'Leitura' ao usuário se ainda não estiver adicionada
				const hasFoundReadAssignment =
					subModule.assignments.find(assignment => assignment.readableName === 'Leitura')

				if (hasFoundReadAssignment && !this.newUser.assignments.includes(hasFoundReadAssignment.name)) {
					this.newUser.assignments.push(hasFoundReadAssignment.name)
				}
			}
		}

		// Atualiza o estado de seleção do módulo com base nas atribuições marcadas
		this.assignmentsModules[moduleIndex].isSelected = this.isModuleSelected(moduleIndex)
	}

	/**
	 * Determina se uma caixa de seleção específica deve ser desativada com base nos índices do módulo e submódulo,
	 * e no nome da atribuição.
	 *
	 * @param {number} moduleIndex - Índice do módulo no array assignmentsModules.
	 * @param {number} subModuleIndex - Índice do submódulo no array subModules do módulo.
	 * @param {string} assignmentName - Nome da atribuição para verificar a condição de desabilitação.
	 * @returns {boolean} - Retorna true se a caixa de seleção deve ser desativada, caso contrário false.
	 */
	public shouldDisableCheckbox(moduleIndex: number, subModuleIndex: number, assignmentName: string): boolean {
		// Verifica se a atribuição é 'Leitura'
		if (assignmentName === 'Leitura') {
			// Obtém todas as atribuições do submódulo
			const subModuleAssignments = this.assignmentsModules[moduleIndex].subModules[subModuleIndex].assignments

			// Conta quantas atribuições estão marcadas no submódulo
			const markedAssignmentsCount = subModuleAssignments.filter(
				assignment => this.newUser.assignments.includes(assignment.name) && assignment.readableName !== 'Leitura').length

			// Verifica se o submódulo é 'Histórico'
			const subModule = this.assignmentsModules[moduleIndex].subModules[subModuleIndex]
			if (subModule.name === 'Histórico') {
				// Busca o submódulo 'Relatório' no mesmo módulo
				const module = this.assignmentsModules[moduleIndex]
				if (module) {
					const subModuleReport = module.subModules.find(subModule => subModule.name === 'Relatório')

					if (subModuleReport) {
						// Filtra atribuições marcadas em 'Relatório' excluindo 'Leitura'
						const assignmentsReport = subModuleReport.assignments.filter(assignment =>
							this.newUser.assignments.includes(assignment.name) && assignment.readableName !== 'Leitura')

						// Se existem atribuições marcadas em 'Relatório', a caixa 'Leitura' deve ser desativada
						if (assignmentsReport.length > 0) return true
					}
				}
			}

			// Se mais de uma atribuição estiver marcada, desativa a caixa de 'Leitura'
			return markedAssignmentsCount > 0
		} else if (assignmentName === 'Leitura de todos') {
			// Obtém todas as atribuições do submódulo
			const subModuleAssignments = this.assignmentsModules[moduleIndex].subModules[subModuleIndex].assignments

			// Conta quantas atribuições estão marcadas no submódulo
			const markedAssignmentsCount = subModuleAssignments.filter(assignment =>
				this.newUser.assignments.includes(assignment.name) &&
				assignment.readableName === 'Atualização de todos'
			).length

			// Se mais de uma atribuição estiver marcada, desativa a caixa de 'Leitura'
			return markedAssignmentsCount > 0
		}

		// Por padrão, não desativa a caixa de seleção
		return false
	}


	public isModuleSelected(moduleIndex: number): boolean {
		const module = this.assignmentsModules[moduleIndex]
		return module.subModules.every(subModule =>
			subModule.assignments.every(assignment =>
				this.newUser.assignments.includes(assignment.name)
			)
		)
	}

	public searchTruncated(value: string) {
		this.searchTruncatedStringFormated = value
		this.fetchUsers()
	}

	public updateLengthTable(newLength: string) {
		this.datatableOptions.pageLength = parseInt(newLength)
		this.rerender()
		setLengthTable(newLength)
	}

	public runToInitTable() {
		const table: HTMLDivElement =
			document.getElementsByClassName('datatables-content')[0] as HTMLDivElement

		scrollToConteiner(table)
		insertOrRemoveClassInScrollButton()
	}
}
